import {
  IAvailableExternalInputModel,
  IFontTestDossierDataInputModel,
  IUpdateFontStatusInputModel,
} from 'inputModels';
import { api } from 'services';
import {
  IAvailableExternalFontViewModel,
  IExternalFontExecutionViewModel,
  IResponse,
  IVoidResponse,
} from 'viewModels';

const getExternalFonts = () =>
  new Promise<IResponse<IAvailableExternalFontViewModel[]>>(
    (resolve, reject) => {
      api
        .get('externalfont/list')
        .then(({ data }) => resolve(data))
        .catch(reject);
    }
  );

const getExternalFontsDetails = () =>
  new Promise<IResponse<IAvailableExternalFontViewModel[]>>(
    (resolve, reject) => {
      api
        .get('externalfont/details')
        .then(({ data }) => resolve(data))
        .catch(reject);
    }
  );

const updateExternalFont = (input: IUpdateFontStatusInputModel) =>
  new Promise<IVoidResponse>((resolve, reject) => {
    api
      .post('externalfont/update-status', input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const executeFontTest = (inputData: IFontTestDossierDataInputModel) =>
  new Promise<IResponse<IExternalFontExecutionViewModel>>(
    (resolve, reject) => {
      api
        .post(`externalfont/test`, inputData)
        .then(({ data }) => resolve(data))
        .catch(reject);
    }
  );

const cleanFontsMetrics = () =>
  new Promise<IVoidResponse>((resolve, reject) => {
    api
      .delete('externalfont/clean-metrics')
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const editExternalFont = (input: IAvailableExternalInputModel) =>
  new Promise<IVoidResponse>((resolve, reject) => {
    api
      .put('externalfont/edit', input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

export const ExternalFontController = {
  getExternalFonts,
  getExternalFontsDetails,
  updateExternalFont,
  executeFontTest,
  cleanFontsMetrics,
  editExternalFont,
};
